/**
 * Avisa a Google Analytics cada cambio de pagina (SEO-05).
 *
 * En una SPA el navegador no recarga, asi que GA no ve mas que la primera
 * pagina si nadie le avisa. No dibuja nada: vive junto al enrutador para poder
 * leer la ubicacion. Sin `VITE_GA_ID` no hace nada (`analitica.ts`).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { iniciarAnalitica, registrarVistaDePagina } from './analitica';

export function SeguimientoDePaginas() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    iniciarAnalitica();
  }, []);

  useEffect(() => {
    // Un instante despues: el titulo lo escribe `<Seo>` al montar la vista, y si
    // se lee antes GA registraria la pagina nueva con el titulo de la anterior.
    const espera = window.setTimeout(() => registrarVistaDePagina(`${pathname}${search}`), 300);
    return () => window.clearTimeout(espera);
  }, [pathname, search]);

  return null;
}
